import { DateTime } from 'luxon';

export const isOrderWithRetentionDateExpiredAndWithPalletsToSend = (
   retentionDate: DateTime,
   isBeforeToPayStatus: boolean,
) => {
   const isRetentionDateExpired = DateTime.now().startOf('day') > retentionDate.startOf('day');
   return isBeforeToPayStatus && isRetentionDateExpired;
};
